import { HOC } from 'formsy-react';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import globals from '../../../globals/communityGlobals';
import { insertSpaces } from '../../../utils/helpers';

const locale = globals.getArea('error');
const styles = {
  error: { bottom: 4, fontSize: '11px' },
};
class FormsyNHS extends React.Component {
  constructor(props) {
    super(props);
    this.setValidator(props);
  }

  componentWillReceiveProps(nextProps) {
    this.setValidator(nextProps);
  }

  setValidator = props => {
    props.setValidations(this.validations, props.required);
  };

  validations = {
    length: (values, value = '') =>
      typeof value === 'undefined' || value.length <= 0 || value.length === 10
        ? true
        : locale.getMsg('nhsIncorrectLength'),
    checksum: (values, value = '') => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }
      const invalidMessage = locale.getMsg('nhsInvalid');
      const digitsArray = value.split('').map(digit => parseInt(digit, 10));

      if (!this.isValidNhsNumber(digitsArray)) {
        const lastDigit = this.calculateLastDigit(digitsArray);
        if (
          this.isCheckDigitCorrect(lastDigit, digitsArray) &&
          (this.isValidChiNumberDate(value) || this.isValidHncNumber(value))
        ) {
          return true;
        }
        return invalidMessage;
      }

      return true;
    },
  };

  isValidDate = dateNumber => {
    const dateString = dateNumber.toString();
    const day = parseInt(dateString.substring(0, 2), 10);
    const month = parseInt(dateString.substring(2, 4), 10);
    const year = parseInt(`${dateString.substring(4, 6)}`, 10);

    const value = moment([year, month, day]);
    return value.isValid();
  };

  isValidNhsNumber = digitsArray => {
    const multiplicationSum = digitsArray.reduce(
      (prevValue, currentValue, index) => (index < 9 ? prevValue + currentValue * (10 - index) : prevValue),
      0,
    );

    const remainder = multiplicationSum % 11;
    const checkDigit = 11 - remainder;

    return this.isCheckDigitCorrect(checkDigit, digitsArray);
  };

  isValidChiNumberDate = value => {
    const dateNumber = value.substring(0, 6);
    return this.isValidDate(dateNumber);
  };

  isValidHncNumber = value => {
    const parse = parseInt(value, 10) / 10;
    return parse <= 399999999 && parse <= 320000001;
  };

  calculateLastDigit = digitsArray => {
    let lastDigit = 0;
    let position = 1;

    const digits = digitsArray.slice(0, -1);
    digits.forEach(digit => {
      lastDigit += digit * position;
      position += 1;
    });
    lastDigit %= 11;

    return lastDigit;
  };

  isCheckDigitCorrect = (checkDigit, digitsArray) => {
    if (checkDigit === 11) {
      checkDigit = 0;
    }

    return checkDigit === digitsArray[9];
  };

  handleChange = (event, newValue) => {
    let newValueTrimmed = newValue.replace(/[^0-9]+/g, '');
    const currentValue = this.props.getValue() || '';
    if (newValueTrimmed.length < currentValue.length) {
      if (newValueTrimmed.length !== currentValue.length - 1) {
        newValueTrimmed = currentValue.slice(0, newValueTrimmed.length);
      } else {
        newValueTrimmed = currentValue.slice(0, currentValue.length - 1);
      }
    }
    newValueTrimmed = newValueTrimmed.slice(0, 10);
    this.props.setValue(newValueTrimmed.length <= 0 ? undefined : newValueTrimmed);
  };

  formatVisibleInput = (input = '') => {
    let formattedInput = input.slice();
    if (input.length > 0) {
      if (input.length > 6) {
        if (input.charAt(6) !== ' ') {
          formattedInput = insertSpaces(formattedInput, 6);
        }
        if (input.charAt(3) !== ' ') {
          formattedInput = insertSpaces(formattedInput, 3);
        }
      } else if (input.length > 3) {
        if (input.charAt(3) !== ' ') {
          formattedInput = insertSpaces(formattedInput, 3);
        }
      }
    }
    return formattedInput;
  };

  render() {
    const {
      getErrorMessage,
      getValue,
      setValidations,
      setValue,
      value,
      resetValue,
      hasValue,
      getErrorMessages,
      isFormDisabled,
      isValid,
      isPristine,
      isFormSubmitted,
      isRequired,
      showRequired,
      showError,
      isValidValue,
      validationColor,
      validationError,
      validationErrors,
      ...restOfProps
    } = this.props;
    const currentValue = getValue();
    const visibleInput = this.formatVisibleInput(currentValue);
    const shouldShowError = typeof currentValue !== 'undefined' && !this.props.isPristine();
    return (
      <TextField
        className="col-c6"
        value={visibleInput}
        onChange={this.handleChange}
        errorText={shouldShowError ? getErrorMessage() : null}
        errorStyle={styles.error}
        {...restOfProps}
      />
    );
  }
}

FormsyNHS.defaultProps = {
  required: false,
  validationError: '',
  validationColor: '',
  validationErrors: {},
  value: undefined,
};

FormsyNHS.propTypes = {
  setValue: PropTypes.func.isRequired,
  getValue: PropTypes.func.isRequired,
  setValidations: PropTypes.func.isRequired,
  required: PropTypes.bool,
  getErrorMessage: PropTypes.func.isRequired,
  isPristine: PropTypes.func.isRequired,
  resetValue: PropTypes.func.isRequired,
  hasValue: PropTypes.func.isRequired,
  getErrorMessages: PropTypes.func.isRequired,
  isFormDisabled: PropTypes.func.isRequired,
  isValid: PropTypes.func.isRequired,
  isFormSubmitted: PropTypes.func.isRequired,
  isRequired: PropTypes.func.isRequired,
  showRequired: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  isValidValue: PropTypes.func.isRequired,
  validationColor: PropTypes.string,
  validationError: PropTypes.string,
  validationErrors: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.string,
};

export default HOC(FormsyNHS);
